/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchActorsSkeleton.defs'
export { main as default } from './searchActorsSkeleton.defs'
